import { Timezone } from "@/models/facility/Timezone";

export const timezones: Timezone[] = [
  {
    text: "Eastern",
    value: "America/New_York"
  },
  {
    text: "Central",
    value: "America/Chicago"
  },
  {
    text: "Mountain",
    value: "America/Denver"
  },
  {
    text: "Pacific",
    value: "America/Los_Angeles"
  }
];
